import { Injectable } from '@jack-henry/frontend-utils/di';
import { CompanyUserSummary } from '@treasury/domain/company/user';
import { RowActionCommand, RowActionCommandResult } from '../base.cmd';
import { CompanyUserActionType } from './user-actions.types';

@Injectable()
export class SecurityAndPasswordSettingsCommand implements RowActionCommand<
    CompanyUserSummary,
    CompanyUserActionType
> {
    constructor() {}

    public command(
        isUisEnabled: boolean
    ): RowActionCommandResult<CompanyUserSummary, CompanyUserActionType> {
        return {
            type: CompanyUserActionType.SecurityAndPasswordSettings,
            title: 'Security and Password Settings',
            hiddenCondition: (user: CompanyUserSummary) => !user.hasDigitalId || !isUisEnabled,
            action: (user: CompanyUserSummary) => this.execute(user),
        };
    }

    private execute(user: CompanyUserSummary) {
        window.open(user.securityAndPasswordSettingsLink, '_blank');
    }
}
